import { useState } from "react";
import axios from "axios";
import { getApiUrl } from "../../config/api";

function BankLimitModal({ account, bankLimit, onClose, onRefresh }) {
  const [formData, setFormData] = useState({
    acc: account.id,
    year: bankLimit ? bankLimit.year : "",
    limit: bankLimit ? bankLimit.limit : "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const accessToken = localStorage.getItem("access_token");

    const url = bankLimit
      ? getApiUrl(`/PartnerFiles/api/bank-limits/${bankLimit.id}/`)
      : getApiUrl("/PartnerFiles/api/bank-limits/create/");

    const method = bankLimit ? "PUT" : "POST";

    try {
      await axios({
        method: method,
        url: url,
        data: formData,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      alert(`Bank limit ${bankLimit ? "updated" : "added"} successfully!`);
      onRefresh(); // Refresh the data in the parent component
      onClose();
    } catch (error) {
      console.error("Error saving bank limit:", error);
      alert("Failed to save bank limit. Please try again.");
    }
  };

  return (
    <div
      className="fixed inset-0 flex justify-center items-center z-50"
      id="banklimitmodalopen"
      style={{ width: "100vw", height: "100vh" }}
    >
      <div
        className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"
        style={{
          width: "100vw",
          height: "150%",
          background: "black",
          backgroundSize: "200% 200vh",
          overflowY: "hidden",
          paddingBottom: "150px",
        }}
      ></div>
      <div
        className="relative bg-white w-4/5 max-w-2xl rounded-lg shadow-lg"
        style={{
          height: "auto",
          maxHeight: "95vh",
          overflowY: "auto",
        }}
      >
        <div style={{ padding: "40px 60px" }}>
          <h2 className="text-center text-blue-700 text-2xl font-bold mb-6">
            {bankLimit ? "Edit Bank Limit" : "Add Bank Limit"}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="bg-blue-500 text-white px-3 py-2 rounded hover:bg-red-700 transition-colors"
            style={{ position: "absolute", top: "20px", right: "20px" }}
          >
            X
          </button>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label
                htmlFor="year"
                className="block text-sm font-medium text-gray-700"
              >
                Financial Year (e.g., 2026)
              </label>
              <input
                id="year"
                type="text"
                name="year"
                value={formData.year}
                onChange={handleChange}
                placeholder="2026"
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="space-y-2">
              <label
                htmlFor="limit"
                className="block text-sm font-medium text-gray-700"
              >
                Bank Limit Amount
              </label>
              <input
                id="limit"
                type="number"
                name="limit"
                value={formData.limit}
                onChange={handleChange}
                placeholder="2000000"
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="flex justify-end space-x-4 mt-8">
              <button
                type="button"
                onClick={onClose}
                className="px-6 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {bankLimit ? "Save Changes" : "Add Limit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default BankLimitModal;
